import {
  Box,
  Container,
  Grid,
  Typography,
  makeStyles,
} from "@material-ui/core";
import { useSelector } from "react-redux";
import { getOrderDate } from "../utils";
import { CollectOrderListModel } from "../redux/actions/collectOrders";
import { CollectOrderStamp } from "./CollectOrderStamp";
import { textButtonHoverAndActive } from "../utils/styles/buttonStyles";
import { Stamp } from "../components-atoms";

const useStyles = makeStyles(() => ({
  root: {
    marginTop: 24,
    marginBottom: "24px",
    padding: "24px",
    boxSizing: "border-box",
    border: "1px solid rgba(0, 0, 0, 0.08)",
    borderRadius: "20px",
    cursor: "pointer",
    transition: "all 200ms ease",
    "@media (max-width: 900px)": {
      flexDirection: "column",
      alignItems: " flex-start",
      border: "unset",
    },
    ...textButtonHoverAndActive
  },
  leftContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-start",
    textAlign: "left",
    "& > .MuiTypography-body2": {
      marginTop: 4,
    },
  },
  rightContainer: {
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    textAlign: "right",
    "& > .MuiTypography-subtitle2": {
      marginTop: 4,
    },
    "@media (max-width: 899px)": {
      alignItems: "flex-start",
      textAlign: "left",
      marginTop: 8,
    },
  },
}));

export enum ICollectOrderItemSource {
  "Open" = "Open",
  "OutForDelivery" = "OutForDelivery",
  "Failed" = "Failed",
  "Archived" = "Archived",
}

interface ICollectionOrderItemProps {
  data: CollectOrderListModel;
  // eslint-disable-next-line no-unused-vars
  onClick: (id: string) => void;
  index: number;
  source?: ICollectOrderItemSource;
}
export function CollectionOrderItem({
  index,
  data,
  source,
  onClick,
}: ICollectionOrderItemProps) {
  const classes = useStyles();
  const orderDate = getOrderDate(data?.Drafted?.toString());
  const role = useSelector((state: any) => state.login.role);
  const isTKAdmin = role === "Admin";
  const isMerchant = role === "Merchant";

  const renderInfo = () => {
    switch (source) {
      case ICollectOrderItemSource.Failed:
        return (
          <Grid item xs={12} sm className={classes.rightContainer}>
            <Typography variant="body2" component="span" color="textSecondary">
              Failed on
            </Typography>
            <Typography variant="subtitle2" component="span" color="textPrimary">
              {getOrderDate(data.Failed)}
            </Typography>
          </Grid>
        );
      case ICollectOrderItemSource.Archived:
        return (
          <Grid item xs={12} sm className={classes.rightContainer}>
            <Typography variant="body2" component="span" color="textSecondary">
              Last Update
            </Typography>
            <Typography variant="subtitle2" component="span" color="textPrimary">
              {getOrderDate(data.LatestUpdateForArchived)}
            </Typography>
          </Grid>
        );
      default:
        return (
          <Grid item xs={12} sm className={classes.rightContainer}>
            <Typography variant="body2" component="span" color="textSecondary">
              Collection Time
            </Typography>
            <Typography variant="subtitle2" component="span" color="textPrimary">
              {getOrderDate(data.PickUpTime)}
            </Typography>
          </Grid>
        );
    }
  };

  return (
    <Container
      data-testid="delivery-order-item"
      data-order="delivery-order-item"
      data-index={index}
      onClick={() => onClick(data.Id)}
      className={classes.root}
    >
      <Grid container>
        <Grid item xs className={classes.leftContainer}>
          <Box display="flex" alignItems="center">
            <Typography variant="h6" component="span" color="textPrimary">
              #{data.ReferenceNumber}
            </Typography>
            {data.PremiumSelected && (
              <Box>
                <Stamp type="success" text="Concierge" />
              </Box>
            )}
            {data.Status && (
              <Box>
                <CollectOrderStamp status={data.Status} />
              </Box>
            )}
            {(isTKAdmin && data.ManuallyResolved) && (
              <Box>
                <Stamp type="warning" text="Manually Resolved" />
              </Box>
            )}
          </Box>

          {isTKAdmin || isMerchant ?
            <Typography variant="body2" component="span" color="textSecondary">
              {orderDate}<strong> · {data?.BookedBy ? data?.BookedBy : data?.MerchantName}</strong>
            </Typography>
            :
            <Typography variant="body2" component="span" color="textSecondary">
              {orderDate}
            </Typography>
          }
        </Grid>
        {renderInfo()}
      </Grid>
    </Container>
  );
}

export default CollectionOrderItem;
